import { Button, Popover } from "@mui/material";
import { format } from "date-fns";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import csLocale from "date-fns/locale/cs";
import deLocale from "date-fns/locale/de";
import atLocale from "date-fns/locale/de-AT";
import enLocale from "date-fns/locale/en-GB";
import esLocale from "date-fns/locale/es";
import frLocale from "date-fns/locale/fr";
import itLocale from "date-fns/locale/it";
import ltLocale from "date-fns/locale/lt";
import nlLocale from "date-fns/locale/nl";
import beLocale from "date-fns/locale/nl-BE";
import plLocale from "date-fns/locale/pl";
import roLocale from "date-fns/locale/ro";
import skLocale from "date-fns/locale/sk";

import { valueFormater } from "./valueFormater";
import YearMonthRangePopover from "./YearMonthRangePopover";

const localeMap = {
	at: atLocale,
	be: beLocale,
	cz: csLocale,
	de: deLocale,
	en: enLocale,
	es: esLocale,
	fr: frLocale,
	it: itLocale,
	lt: ltLocale,
	nl: nlLocale,
	pl: plLocale,
	ro: roLocale,
	sk: skLocale,
};

const YearMonthRangePicker = (props) => {
	const { i18n } = useTranslation();
	const { buttonPros, value, onChange } = props;
	const locale = i18n.language || "pl";

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const formatDate = useCallback(
		(date, formatStr) => format(date, formatStr, { locale: localeMap[locale] }),
		[locale]
	);

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<Button
				{...buttonPros}
				onClick={handleClick}
				sx={{ ...buttonPros?.sx, whiteSpace: "nowrap" }}
				variant="contained"
			>
				{valueFormater(formatDate, value)}
			</Button>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<YearMonthRangePopover
					{...props}
					onChange={(v) => {
						onChange(v);
						handleClose();
					}}
					dateFormater={formatDate}
				/>
			</Popover>
		</>
	);
};

export default YearMonthRangePicker;
